import { createApp } from 'vue'
import App from './App.vue'
import { settings } from './core/settings/DynamicSettings'
import { createPinia } from 'pinia'
import { setBaseUrl, i18n } from './core/config'
import router from './core/config/router'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'
const app = createApp(App)
const pinia = createPinia()
import 'primeicons/primeicons.css'
import { loadPrimeVue } from './core/config/theme'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from './core/config/queryClient'
import { useAuthStore } from './modules/auth'
import { permissionDirective } from './core/directives/permission'

setupApp().then(() => {
  loadPrimeVue(app)

  app.use(VCalendar)
  app.use(pinia).use(router).use(i18n).use(VueQueryPlugin, { queryClient })

  app.directive('permission', permissionDirective)

  const authStore = useAuthStore()

  // Montamos la aplicación de inmediato para que el DOM y el loader (LoadingOverlay) se dibujen.
  app.mount('#app')

  // Ejecutamos silenciosamente checkAuth en background.
  // Mientras se resuelve, App.vue oculta las vistas usando isAuthenticating.
  authStore.checkAuth()
})

async function setupApp() {
  setBaseUrl(import.meta.env.VITE_API_URL)
}
